export default {
  summary: 'Chýbajúce oprávnenia Keycloak',
  details: 'Aktuálny používateľ nemá požadované klientske roly v Keycloak. Vytváranie nových používateľov ani úprava existujúcich nie je možná. Priraďte používateľovi chýbajúce roly alebo kontaktujte technickú podporu Nitrex',
};
